import {
  Film,
  Mic,
  Smartphone,
  Calendar,
  Users,
  ArrowUpRight,
} from "lucide-react";
import Section from "@/components/editorial/Section";
import SectionHeader from "@/components/editorial/SectionHeader";
import { ECOSYSTEM } from "@/data/content";

const ICONS = { Film, Mic, Smartphone, Calendar, Users };

export default function Ecosystem() {
  return (
    <Section tone="cream" padding="xl" testid="ecosystem-section">
      <div className="mb-14">
        <SectionHeader
          eyebrow="Ecosistema"
          title={
            <>
              Cinco formatos.<br />
              <span className="italic">Una sola misión.</span>
            </>
          }
          description="De la cámara al micrófono, del feed al encuentro. Una misma historia, contada en cinco lenguajes."
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
        {ECOSYSTEM.map((item, i) => {
          const Icon = ICONS[item.icon];
          return (
            <a
              key={item.title}
              href="#"
              data-testid={`ecosystem-${item.title.toLowerCase()}`}
              className="group relative flex flex-col justify-between p-7 md:p-8 bg-white border border-charcoal/10 rounded-sm hover:border-terracotta transition-all duration-[400ms] [transition-timing-function:cubic-bezier(0.22,1,0.36,1)] hover:-translate-y-1 min-h-[280px]"
              style={{ animationDelay: `${i * 60}ms` }}
            >
              <div>
                {Icon && (
                  <Icon
                    strokeWidth={1.25}
                    className="h-7 w-7 text-terracotta mb-6 transition-transform duration-[400ms] group-hover:scale-110"
                  />
                )}
                <h3 className="font-serif text-2xl font-light text-charcoal mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-charcoal/70 leading-relaxed">
                  {item.desc}
                </p>
              </div>
              <div className="mt-6 inline-flex items-center gap-1 text-xs uppercase tracking-[0.22em] text-charcoal group-hover:text-terracotta transition-colors">
                Explorar
                <ArrowUpRight className="h-3.5 w-3.5" />
              </div>
            </a>
          );
        })}
      </div>
    </Section>
  );
}
